import { render, staticRenderFns } from "./mobileCourseDetail.vue?vue&type=template&id=c8ab503c&scoped=true"
import script from "./mobileCourseDetail.vue?vue&type=script&lang=js"
export * from "./mobileCourseDetail.vue?vue&type=script&lang=js"
import style0 from "./mobileCourseDetail.vue?vue&type=style&index=0&id=c8ab503c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ab503c",
  null
  
)

export default component.exports